import axios from "axios";
import { POST } from "../adapters/xhr";

export default function (licenceApplicationId, id, equipmentTypeCategoryId) {
    return async (dispatch, getState) => {
        var requestData = {
            licenceApplicationId,
            id,
            equipmentTypeCategoryId
        };

        try {
            const response = await axios({
                method: "GET",
                url: "api/Equipment/CheckDeleteEquipmentForLicenceAmendment",
                params: requestData,
                withCredentials: true
            });

            dispatch({
                type: "LICENCE_AMENDMENT",
                data: response.data
            });
            
            if (response.data) {
                // Create payment record synchronously for amendments during reviews
                // Get amendment price from pricing configuration
                //Please work....
                const state = getState();
                const amendmentPaymentDetail = state.availablePricings.find(p => p.id === 3); // AmendLicence = 3
                const amendmentPaymentAmount = Number(amendmentPaymentDetail?.price) || 0;
                
                if (amendmentPaymentAmount > 0) {
                    const paymentModel = {
                        id: 0,
                        transId: null,
                        licenceApplicationId: Number(licenceApplicationId) || 0,
                        paymentAmount: amendmentPaymentAmount,
                        created: new Date(),
                        createdBy: ""
                    };
                    
                    try {
                        const paymentResponse = await POST("api/LicenceApplication/NewLicencePayment", paymentModel);
                        if (paymentResponse.status === 200) {
                            dispatch({
                                type: "LICENCE_PAYMENT_RETRIEVED",
                                data: paymentResponse.data.licencePayment
                            });
                        } else {
                            console.error(`Payment creation failed with status ${paymentResponse.status}`);
                        }
                    } catch (paymentError) {
                        console.error('Payment creation failed:', paymentError);
                        // Payment creation failed, but continue with the equipment deletion
                    }
                } else {
                    console.warn('No amendment pricing found in configuration');
                }
            }
        } catch (error) {
            console.error("CreateCheckDeleteEquipmentForAmendmentAction: Error", error);
        }
    };
}
